import { useIncomingCalls } from '@hit/react-jssip';
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const useNavigateOnIncomingCall = () => {
  const [incomingCall] = useIncomingCalls();
  const navigate = useNavigate();

  useEffect(() => {
    if (incomingCall) {
      navigate({ to: '/phone' });
    }
  }, [incomingCall, navigate]);
};
